import { User, UserManager } from 'oidc-client';
import React, { useState, useEffect, useCallback } from 'react';
import { SecurityContext } from './security.context';

const DefaultLoadingElement = (<span>loading...</span>);
const DefaultUnauthenticatedElement = (<span>Default Unauthenticated Element</span>);
const DefaultUnauthorizedElement = (<span>Default Unauthorized Element</span>);

const emptyUser = {} as User;
type fnOnLog = (m: any[] | string) => void

interface ISecurityProviderProps {
  children: any,
  userManager: UserManager,
  onLog?: fnOnLog,
  LoadingElement?: JSX.Element,
  UnauthenticatedElement?: JSX.Element,
  UnauthorizedElement?: JSX.Element,
  DefaultRoles?: string[],
}

export const SecurityProvider = (props: ISecurityProviderProps) => {
  const [user, setUser] = useState(emptyUser);
  const [isLoading, setIsLoading] = useState(true);

  const log = (m: any[] | string): void => { props.onLog && props.onLog(m) };
  const defaultRoles: string[] = props.DefaultRoles ?? [];

  const loadingElement = props.LoadingElement ?? DefaultLoadingElement;
  const unauthenticatedElement = props.UnauthenticatedElement ?? DefaultUnauthenticatedElement;
  const unauthorizedElement = props.UnauthorizedElement ?? DefaultUnauthorizedElement;

  const userManager = props.userManager;

  useEffect(() => {
    userManager.getUser().then((u) => {
      log(['USERMANAGER::GETUSER::', u, user]);
      if (u) {
        setUser(u);
      }
      setIsLoading(false);
    });
  }, []);

  const userLoadedEventHandler = useCallback((loadedUser) => {
    setUser(loadedUser);
  }, []);

  useEffect(() => {
    userManager.events.addUserLoaded(userLoadedEventHandler);

    return () => {
      userManager.events.removeUserLoaded(userLoadedEventHandler);
    };
  }, [userManager.events, userLoadedEventHandler]);

  return (
    <SecurityContext.Provider value={{ user, userManager, unauthenticatedElement, unauthorizedElement, defaultRoles, log}}>
      {isLoading ? loadingElement : props.children}
    </SecurityContext.Provider>
  );
};
